﻿import TKBasketAction, { BasketData, BasketAction } from '@tk/utilities/tk.basket.action';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import { sendNotificationByItem } from '@tk/utilities/tk.notification';

const eventMap = {
    added: 'opc_cart_add',
    deleted: 'opc_cart_remove',
    changed: 'opc_cart_update',
};

interface BasketResponse {
    total: string;
}

interface TrackBasketItem {
    sku: string;
    name: string;
    category: string[];
    price: number;
    quantity: number;
}

interface TrackBasketResponse {
    items: TrackBasketItem[];
    data: { totalAmount: number; currency: string; }
}

export default class KWBasketAction extends TKBasketAction {
    totalAmounts: NodeListOf<HTMLDivElement>;

    constructor(component: HTMLElement) {
        super(component);

        this.totalAmounts = document.querySelectorAll('[data-tk-basket-total-amount]');
        [this.totalAmount = undefined] = this.totalAmounts;
    }

    refreshResultList(response: TKResponse<BasketData>) {
        this.emit({
            action: BasketAction.REFRESHED_LIST,
            data: response.dataAsJson,
        });

        if (!response.success) return;
        this.updateMiniBasket(response.dataAsJson);
        this.updateBasket(response.dataAsJson);
        if (response.dataAsJson.action === 'added') {
            sendNotificationByItem(this.getQuantityMessage());
        }

        const { action } = response.dataAsJson;
        this.updateCartTracker(action);
    }

    updateCartTracker(action: string) {
        const urlElement = document.querySelector('[data-tk-basket-tracker]');
        const url = urlElement?.getAttribute('data-tk-url');
        if (!url) return;
        fetchRequest({
            requestURL: url,
            resolveHandler: this.handleCartTracker.bind(this, action),
        });
    }


    handleCartTracker(action: string, response: TKResponse<TrackBasketResponse>) {
        if (!response || !response.dataAsJson) return;
        const { items, data } = response.dataAsJson;

        const mtm = window._mtm as unknown[];
        mtm.push({
            event: eventMap[action as keyof typeof eventMap],
            location: window.location.href,
            currency: data.currency,
            value: data.totalAmount,
            items,
        });
    }

    refreshBasketTotal(response: TKResponse) {
        if (!response || !response.dataAsJson) return;
        const data = response.dataAsJson as BasketResponse;

        this.totalAmounts.forEach((element) => {
            element.innerHTML = data.total;
        });
    }

    updateBasket(data: BasketData) {
        if (!this.basketList) return;

        const { tkAction } = this.component.dataset;
        if (tkAction === 'delete' || tkAction === 'deleteall') {
            const openDialog = document.querySelector('dialog[open]')
            if (data.quantity === 0 && !openDialog) {
                window.location.reload();
            } else {
                const basketPos = this.basketList.querySelector(`[data-tk-internalno="${this.component.dataset.tkInternalno}"]`)
                    || this.component.closest('[data-tk-basket-item]');
                if (basketPos) basketPos.remove();
            }
        } else if (tkAction === 'change') {
            const item = this.component.closest('[data-tk-basket-item]');
            // update item price and amount
            const price = item?.querySelector('[data-tk-basket-item-price]');
            if (price) {
                price.innerHTML = `${data.currency} ${data.itemPrice}`;
            }
            const amount = item?.querySelector('[data-tk-basket-item-amount]');
            if (amount) {
                amount.innerHTML = `${data.currency} ${data.itemAmount}`;
            }
        } else if (this.component.closest('tk-quick-order')) {
            // update after quickorder
            const quickorder = this.component.closest<HTMLElement>('tk-quick-order');
            if (!quickorder) return;
            fetchRequest({
                requestURL: quickorder.dataset.tkUrlRefresh || window.location.href,
                resolveHandler: this.refreshBasketList.bind(this),
            });
        }
        // update total amount and VAT
        if (this.totalAmount) {
            // this.totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
            const url = this.totalAmount.getAttribute('data-tk-basket-amount-url');
            if (url) {
                fetchRequest({
                    requestURL: url,
                    resolveHandler: this.refreshBasketTotal.bind(this),
                });
            }
        }

        const totalVat = this.basketList.querySelector('[data-tk-basket-total-vat]');
        if (totalVat) {
            totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
        }

        this.emit({ action: BasketAction.REFRESHED_BASKET });
    }
}
